import React from 'react';

/**
 * Big, stark confluence score gauge. 0-100.
 * Segmented radial with giant number in middle.
 */
export default function ConfluenceGauge({ value = 0, signal = 'HOLD', size = 200, testId = 'confluence-gauge' }) {
  const v = Math.max(0, Math.min(100, value || 0));
  const seg = 40; // number of ticks
  const active = Math.round((v / 100) * seg);
  const color =
    signal === 'BUY' ? '#00FF41'
    : signal === 'SELL' ? '#FF003C'
    : signal === 'WAIT' ? '#FFD700'
    : '#08F7FE';

  const radius = size / 2 - 14;
  const center = size / 2;

  const ticks = [];
  for (let i = 0; i < seg; i++) {
    const angle = (Math.PI * 1.25) - (Math.PI * 1.5) * (i / (seg - 1));
    const x1 = center + Math.cos(angle) * (radius - 12);
    const y1 = center - Math.sin(angle) * (radius - 12);
    const x2 = center + Math.cos(angle) * radius;
    const y2 = center - Math.sin(angle) * radius;
    const isActive = i < active;
    ticks.push(
      <line
        key={i}
        x1={x1} y1={y1} x2={x2} y2={y2}
        stroke={isActive ? color : '#222'}
        strokeWidth={isActive ? 3 : 2}
        opacity={isActive ? 1 : 0.6}
      />
    );
  }
  return (
    <div data-testid={testId} className="flex flex-col items-center justify-center select-none">
      <svg width={size} height={size * 0.8} viewBox={`0 0 ${size} ${size * 0.8}`}>
        {ticks}
      </svg>
      <div className="-mt-10 text-center">
        <div
          className="font-display font-bold text-6xl"
          style={{ color, textShadow: `0 0 12px ${color}99` }}
          data-testid="confluence-value"
        >
          {v}
        </div>
        <div className="font-display tracking-[0.35em] text-[11px] text-[var(--txt-secondary)] uppercase">
          confluence
        </div>
      </div>
    </div>
  );
}
